import createReducer from 'utils/createReducer';
import {
  OPEN_ADD_NEW_USER_MODAL,
  CLOSE_ADD_NEW_USER_MODAL,
  GET_ALL_ROLES_SUCCESS,
  SET_CHECK_FIELD,
  SET_CREATING_USER_STATE,
  SET_CREATED_USER_STATE,
  GET_ALL_INTERNAL_USERS_SUCCESS,
  GET_ACCESS_LOGS_SUCCESS,
  GETTING_ACCESS_LOGS,
  OPEN_EDIT_INTERNAL_USER_MODAL,
  CLOSE_EDIT_INTERNAL_USER_MODAL,
  UPDATING_INTERNAL_USER,
  SET_CHECK_FIELD_GIVEN_ROLES,
  OPEN_DELETE_INTERNAL_USER_MODAL,
  CLOSE_DELETE_INTERNAL_USER_MODAL,
  DELETING_INTERNAL_USER,
  RESETTING_INTERNAL_USER_PASSWORD,
  OPEN_RESET_INTERNAL_USER_PASSWORD_MODAL,
  CLOSE_RESET_INTERNAL_USER_PASSWORD_MODAL,
  SET_INTERNAL_USER_INPUT_SEARCH,
  SEARCHING_INTERNAL_USER,
  SET_INTERNAL_USER_ROLE_SEARCH,
  CHANGE_INTERNAL_USERS_TABLE_SORT_STATE,
} from 'state/actionTypes';
import { combineReducers } from 'redux';
import { DESCENDING } from '../../constants/access/internalUsersTableSortMethod';

const addUserModal = createReducer(false, {
  [OPEN_ADD_NEW_USER_MODAL]: () => true,
  [CLOSE_ADD_NEW_USER_MODAL]: () => false,
});

const allRoles = createReducer([], {
  [GET_ALL_ROLES_SUCCESS]: (state, { payload }) => {
    const { initialState, data } = payload;
    const { roles } = data;
    let newAllRoles = [];
    for (let i = 0; i < roles.length; i++) {
      let isFound = false;
      for (let j = 0; j < initialState.length; j++) {
        if (initialState[j].id === roles[i].id) {
          newAllRoles = [
            ...newAllRoles,
            { ...initialState[j], isChecked: true },
          ];
          isFound = true;
        }
      }
      if (!isFound)
        newAllRoles = [...newAllRoles, { ...roles[i], isChecked: false }];
    }
    return newAllRoles;
  },
  [SET_CHECK_FIELD]: (state, { payload }) => {
    const { index, currRoles } = payload;
    const newRoles = [...currRoles];
    newRoles[index] = {
      ...newRoles[index],
      isChecked: !newRoles[index].isChecked,
    };
    return newRoles;
  },
  [SET_CHECK_FIELD_GIVEN_ROLES]: (state, { payload }) => {
    const { givenRoles, currState } = payload;
    let newAllRoles = [];
    for (let i = 0; i < currState.length; i++) {
      let isChecked = false;
      for (let j = 0; j < givenRoles.length; j++) {
        if (currState[i].id === givenRoles[j].id) {
          isChecked = true;
        }
      }
      newAllRoles = [...newAllRoles, { ...currState[i], isChecked }];
    }
    return newAllRoles;
  },
});

const creatingUser = createReducer(false, {
  [SET_CREATING_USER_STATE]: (state, { payload }) => payload,
  [SET_CREATED_USER_STATE]: () => false,
});

const internalUsers = createReducer(
  {},
  {
    [GET_ALL_INTERNAL_USERS_SUCCESS]: (state, { payload }) => {
      return payload;
    },
  }
);

const gettingAccessLogs = createReducer(false, {
  [GETTING_ACCESS_LOGS]: (state, { payload }) => payload,
});

const accessLogs = createReducer(
  {},
  {
    [GET_ACCESS_LOGS_SUCCESS]: (state, { payload }) => {
      const { currState, newState } = payload;

      if (Object.keys(currState).length === 0) {
        return newState;
      }

      const retState = { ...currState };
      const newLogData = [...retState.data.internal_tools_activities].concat(
        newState.data.internal_tools_activities
      );

      retState.data = {
        ...retState.data,
        internal_tools_activities: newLogData,
      };

      retState.paging = {
        ...retState.paging,
        page: newState.paging.page,
        size: state.paging.size + newState.paging.size,
      };
      return retState;
    },
  }
);

const editModal = createReducer(
  {},
  {
    [OPEN_EDIT_INTERNAL_USER_MODAL]: (state, { payload }) => {
      const { selectedUser } = payload;

      return { isOpen: true, selectedUser };
    },
    [CLOSE_EDIT_INTERNAL_USER_MODAL]: () => {
      return { isOpen: false, selectedUser: {} };
    },
  }
);

const updatingUser = createReducer(false, {
  [UPDATING_INTERNAL_USER]: (state, { payload }) => payload,
});

const deleteModal = createReducer(
  {},
  {
    [OPEN_DELETE_INTERNAL_USER_MODAL]: (state, { payload }) => {
      const { selectedUser } = payload;

      return { isOpen: true, selectedUser };
    },
    [CLOSE_DELETE_INTERNAL_USER_MODAL]: () => {
      return { isOpen: false, selectedUser: {} };
    },
  }
);

const deletingUser = createReducer(false, {
  [DELETING_INTERNAL_USER]: (state, { payload }) => payload,
});

const resetPasswordModal = createReducer(
  {},
  {
    [OPEN_RESET_INTERNAL_USER_PASSWORD_MODAL]: (state, { payload }) => {
      const { selectedUser } = payload;
      return { isOpen: true, selectedUser };
    },
    [CLOSE_RESET_INTERNAL_USER_PASSWORD_MODAL]: () => {
      return { isOpen: false, selectedUser: {} };
    },
  }
);

const resettingUserPassword = createReducer(false, {
  [RESETTING_INTERNAL_USER_PASSWORD]: (state, { payload }) => payload,
});

const inputSearch = createReducer('', {
  [SET_INTERNAL_USER_INPUT_SEARCH]: (state, { payload }) => payload,
});

const searchingInternalUser = createReducer(false, {
  [SEARCHING_INTERNAL_USER]: (state, { payload }) => payload,
});

const roleSearch = createReducer(
  {},
  {
    [SET_INTERNAL_USER_ROLE_SEARCH]: (state, { payload }) => payload,
  }
);

const internalUserTableSortState = createReducer(
  { sort: { column: 'createdAt', direction: DESCENDING } },
  {
    [CHANGE_INTERNAL_USERS_TABLE_SORT_STATE]: (state, { payload }) => payload,
  }
);

export default combineReducers({
  addUserModal,
  allRoles,
  creatingUser,
  internalUsers,
  accessLogs,
  gettingAccessLogs,
  editModal,
  updatingUser,
  deleteModal,
  deletingUser,
  resetPasswordModal,
  resettingUserPassword,
  inputSearch,
  searchingInternalUser,
  roleSearch,
  internalUserTableSortState,
});
